import React, {useEffect, useState} from 'react';
import {Alert, Button, Form, Input, InputNumber, Modal, Space} from 'antd';
import {CloseOutlined, EditOutlined, PlusOutlined, SaveOutlined} from '@ant-design/icons';
import {createProjectDomain, updateProjectDomain} from '../../api/projectDomainApi';

function ProjectDomainCreateModal({ isOpen, onClose, onSuccess, pjtId, mode = 'create', initialValues = null }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setError('');
      if (mode === 'edit' && initialValues) {
        // 초기값 주입
        form.setFieldsValue({
          domainNm: initialValues.domainNm,
          domainGroupNm: initialValues.domainGroupNm,
          domainClsfNm: initialValues.domainClsfNm,
          dataType: initialValues.dataType,
          dataLen: initialValues.dataLen,
          dcptLen: initialValues.dcptLen,
          strgFrm: initialValues.strgFrm,
          indctFrm: initialValues.indctFrm,
          unit: initialValues.unit,
          prmVl: initialValues.prmVl,
          domainExpln: initialValues.domainExpln,
        });
      } else {
        form.resetFields();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, mode, initialValues]);

  const handleSubmit = async (values) => {
    if (!pjtId) { setError('프로젝트 정보가 없습니다.'); return; }
    setError('');
    setLoading(true);
    try {
      if (mode === 'edit') {
        const id = initialValues?.pjtDomainId;
        await updateProjectDomain(pjtId, id, values);
      } else {
        await createProjectDomain(pjtId, values);
      }
      form.resetFields();
      onSuccess && onSuccess();
      onClose();
    } catch (err) {
      setError(((mode === 'edit') ? '수정에 실패했습니다: ' : '등록에 실패했습니다: ') + (err?.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    setError('');
    onClose();
  };

  const isEdit = mode === 'edit';

  return (
    <Modal
      title={
        <Space>
          {isEdit ? <EditOutlined /> : <PlusOutlined />}
          <span>{isEdit ? '프로젝트 도메인 수정' : '프로젝트 도메인 신규생성'}</span>
        </Space>
      }
      open={isOpen}
      onCancel={handleClose}
      width={900}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
          <Form.Item label="도메인명" name="domainNm" rules={[{ required: true, message: '도메인명을 입력하세요' }]}>
            <Input placeholder="예: 고객ID" />
          </Form.Item>
          <Form.Item label="도메인그룹명" name="domainGroupNm" rules={[{ required: true, message: '도메인그룹명을 입력하세요' }]}>
            <Input placeholder="예: 공통" />
          </Form.Item>
          <Form.Item label="도메인분류명" name="domainClsfNm" rules={[{ required: true, message: '도메인분류명을 입력하세요' }]}>
            <Input placeholder="예: 식별자" />
          </Form.Item>
          <Form.Item label="데이터유형" name="dataType" rules={[{ required: true, message: '데이터유형을 입력하세요' }]}>
            <Input placeholder="예: VARCHAR" />
          </Form.Item>
          <Form.Item label="데이터길이" name="dataLen">
            <Input placeholder="예: 20" />
          </Form.Item>
          <Form.Item label="소수점길이" name="dcptLen">
            <InputNumber placeholder="예: 0" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="저장형식" name="strgFrm" rules={[{ required: true, message: '저장형식을 입력하세요' }]}>
            <Input placeholder="예: TEXT" />
          </Form.Item>
          <Form.Item label="표시형식" name="indctFrm">
            <Input placeholder="예: 999-9999" />
          </Form.Item>
          <Form.Item label="단위" name="unit">
            <Input placeholder="예: 건, 개" />
          </Form.Item>
          <Form.Item label="허용값" name="prmVl">
            <Input placeholder="예: Y,N" />
          </Form.Item>
          <Form.Item label="도메인설명" name="domainExpln" rules={[{ required: true, message: '도메인설명을 입력하세요' }]} style={{ gridColumn: '1 / span 3' }}>
            <Input.TextArea rows={3} placeholder="도메인에 대한 설명을 입력하세요" />
          </Form.Item>
        </div>

        {error && (
          <Alert message="오류" description={error} type="error" showIcon style={{ marginBottom: 16 }} />
        )}

        <div style={{ textAlign: 'right' }}>
          <Button icon={<CloseOutlined />} onClick={handleClose} style={{ marginRight: 8 }}>
            취소
          </Button>
          <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>
            {isEdit ? '수정' : '저장'}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default ProjectDomainCreateModal;
